import React, { useEffect } from 'react';
import { Button, Form, InputGroup, Modal, Spinner } from '@themesberg/react-bootstrap';
import { ErrorMessage } from 'formik';
import DateRangePicker from '../DateRangePicker';
import { formatDate } from '../../utils/dateFormatter';
const BonusForm = ({ values, touched, errors, handleChange, handleBlur, handleSubmit, resetForm, setFieldValue, casinoGameBonus, show, loading, state, setState, handleClose }) => {
  
  useEffect(() => {
    if(casinoGameBonus?.bonusExpiryDate && casinoGameBonus?.bonusStartDate && casinoGameBonus?.bonus){
      setFieldValue('bonusAmount', casinoGameBonus?.bonus)
      setFieldValue('startDate', casinoGameBonus?.bonusStartDate);
      setFieldValue('endDate', casinoGameBonus?.bonusExpiryDate);
    }
  },[casinoGameBonus])

  return(
    <Form>
      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Manage Bonus</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            {casinoGameBonus?.bonusStatus === 'ACTIVE' && <p className='text-danger'>You cannot edit the bonus while it is active.</p>} 
            <label
              htmlFor="bonusAmount"
              className={touched.bonusAmount && errors.bonusAmount ? 'text-danger' : ''}
            >
              Amount
            </label>
            <InputGroup className={touched.bonusAmount && errors.bonusAmount ? 'border border-danger' : ''}>
              <Form.Control
                name="bonusAmount"
                type="number"
                step="any"
                placeholder="Enter the amount"
                value={values.bonusAmount}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={casinoGameBonus?.bonusStatus === 'ACTIVE'}
              />
            </InputGroup>
            <ErrorMessage component="div" name="bonusAmount" className="text-danger" />
          </div>
          <div className="form-group">
            <label className={touched.bonusType && errors.bonusType ? 'text-danger' : ''}>
              Bonus Validity<span className="text-danger"> *</span>
            </label>
            <InputGroup className={touched.bonusType && errors.bonusType ? 'border border-danger' : ''}>
              <DateRangePicker
                width="auto"
                state={state}
                setState={(newState) => {
                  setState(newState);
                  setFieldValue('startDate', formatDate(newState?.[0]?.startDate));
                  setFieldValue('endDate', formatDate(newState?.[0]?.endDate));
                }}
                size="md"
                bonus
                disabled={casinoGameBonus?.bonusStatus === 'ACTIVE'}
              />
            </InputGroup>
          </div>
        </Modal.Body>
        <div className="mt-4 ">
          <Modal.Footer className="d-flex justify-content-between align-items-center">
            <Button
              variant="outline-warning"
              onClick={() => {
                resetForm({ formValues: '' });
                handleClose(false);
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={loading || casinoGameBonus?.bonusStatus === 'ACTIVE'}
              variant="outline-success"
              onClick={handleSubmit}
              className="ml-2"
            >
              Submit
              {loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </Form>
  )
}

export default BonusForm